import type { ThemeMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Alert } from '@hivewatch/dark'

interface DarkAddressChangeAlertIProps {
  isEmergencyCallConfigured: boolean
  isEmergencyCallEnabled: boolean
  hasAddressChanged: boolean
  colorScheme: ThemeMode
}

/**
 * Rebrand variant of {@link AddressChangeAlert} built on the dark `Alert`.
 * Warns that changing a configured facility's address affects emergency
 * calling. Must be rendered within a `DarkProvider` (or a dark `Modal`).
 */
export const DarkAddressChangeAlert = ({
  isEmergencyCallConfigured,
  isEmergencyCallEnabled,
  hasAddressChanged,
  colorScheme,
}: DarkAddressChangeAlertIProps) => {
  const { t } = useTranslation()

  if (
    !isEmergencyCallConfigured ||
    !isEmergencyCallEnabled ||
    !hasAddressChanged
  ) {
    return null
  }

  return (
    <Alert
      colorScheme={colorScheme}
      description={t('facilities:crud_address_change_alert')}
      variant='info'
    />
  )
}
